export const PLAN_COOKIE_KEY = 'selected-plan';
